import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

const API_BASE = process.env.REACT_APP_API_BASE_URL || 'http://localhost:5000';

function ProductsPage() {
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');
  const navigate = useNavigate();

  const fetchProducts = async () => {
    const token = localStorage.getItem('adminToken');

    if (!token) {
      setError('Unauthorized: Admin token missing');
      setLoading(false);
      return;
    }

    try {
      const res = await fetch(`${API_BASE}/api/products`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      if (!res.ok) throw new Error('Failed to fetch products');

      const data = await res.json();
      setProducts(data);
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchProducts();
  }, []);

  const handleDelete = async (id) => {
    const token = localStorage.getItem('adminToken');
    if (!token) {
      alert('Unauthorized: Admin token missing');
      return;
    }

    if (!window.confirm('Are you sure to delete this product?')) return;

    try {
      const res = await fetch(`${API_BASE}/api/products/${id}`, {
        method: 'DELETE',
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      if (!res.ok) throw new Error('Failed to delete product');
      setSuccess('Product deleted successfully');
      fetchProducts();
    } catch (err) {
      alert('Delete error: ' + err.message);
    }
  };
// Helper function to truncate description
const truncateWords = (text, limit = 5) => {
  if (!text) return '-';
  const words = text.split(' ');
  return words.length > limit ? words.slice(0, limit).join(' ') + '...' : text;
};

  return (
    <div className="container my-4">
      <div className="d-flex justify-content-between align-items-center mb-3">
        <h2>Products</h2>
        <button
          className="btn btn-success rounded-pill"
          onClick={() => navigate('/products/add')}
        >
          <i className="bi bi-plus"></i> Add Product
        </button>
      </div>

      {success && <div className="alert alert-success">{success}</div>}
      {loading && <div>Loading products...</div>}
      {error && <div className="alert alert-danger">{error}</div>}

      {!loading && !error && products.length === 0 && (
        <div>No products found.</div>
      )}

      {!loading && !error && products.length > 0 && (
        <div className="table-responsive">
          <table className="table table-striped table-hover align-middle mb-0">
            <thead className="table-success">
              <tr>
                <th>#</th>
                <th>Image</th>
                <th>Name</th>
                <th>Category</th>
                <th>Prices (Weight - ₹)</th>
                <th>Stock</th>
                <th style={{ maxWidth: 250 }}>Description</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              {products.map((prod, idx) => (
                <tr key={prod._id}>
                  <td>{idx + 1}</td>
                  <td>
                    <img
                      src={
                        prod.image ||
                        prod.images?.[0] ||
                        'https://via.placeholder.com/60'
                      }
                      alt={prod.name}
                      style={{
                        width: 60,
                        height: 60,
                        objectFit: 'cover',
                        borderRadius: '0.25rem',
                      }}
                    />
                  </td>
                  <td>{prod.name}</td>
                  <td>{prod.category ?? 'N/A'}</td>
                  <td>
                    {prod.weights?.length > 0
                      ? prod.weights
                          .map((w) => `${w.weight} - ₹${w.price}`)
                          .join(', ')
                      : 'N/A'}
                  </td>
                  <td>{prod.stock ?? 'N/A'}</td>
             <td style={{ maxWidth: 250 }}>{truncateWords(prod.description)}</td>


                  <td>
                    <div className="d-grid gap-2 d-md-flex">
                      <button
                        className="btn btn-sm btn-outline-success"
                        onClick={() => navigate(`/products/edit/${prod._id}`)}
                      >
                        Edit
                      </button>
                      <button
                        className="btn btn-sm btn-danger"
                        onClick={() => handleDelete(prod._id)}
                      >
                        Delete
                      </button>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}

export default ProductsPage;
